import React, { useEffect, useRef, useState } from "react";
import {
    Paging,
    Pager,
    FilterRow,
    ColumnChooser,
    Column,
    Lookup,
    Export,   
    Button as ButtonGrid,   
    Editing,
    Popup,     
    Form, 
    RequiredRule,
    StringLengthRule, 
}
    from 'devextreme-react/data-grid';
   
import { EmailRule, EmptyItem, Item } from 'devextreme-react/form';
import { DataGrid } from 'devextreme-react';
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import {  formatDate, resources,  } from '../../data/app';
import { createStore, createStoreLocal } from "../../utils/proxy";
import uri from "../../utils/uri";
import useAuthorization from "../../hooks/useAuthorization";
import { cellRender } from "../../utils/common";
import http from "../../utils/http";
import { useDispatch } from "react-redux";
import Nuevo from "./Nuevo";
import { goalDialogAction } from "../../store/goal/goalDialogReducer";
import NuevoUsers from "./NuevoUsers";
import { goalUsersDialogAction } from "../../store/goalUsers/goalUsersDialogReducer";
import moment from "moment";

const Goals = props => {

    const [ authorized ] = useAuthorization( resources.gestionGastos );

    let dataGrid = useRef();
    const title = "Metas";        

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                stylingMode:"outlined",
                type:'default',
                icon: 'add',
                text: 'Agregar meta',
                onClick: e => showDialog(0)// dispatch(openDialog({open : true, id : 0}))
            }
        });
    }

    const onSave = (params) => {
        dataGrid.current.instance.refresh();
    }    

    const dispatch = useDispatch();

    const showDialog = (id) => dispatch(goalDialogAction({ open: true, id }));

    const showDialogUsers = (data) => {

        const { id, description, initDate, endDate } = data;

        const text = `${description} Fecha: ${moment(initDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`;
    
        dispatch(goalUsersDialogAction({ open: true, id, text }));
    
    }


    return authorized(
        <div className="container medium">
            <Title title={title} />
            <BlockHeader showFavorite={true} title={title} {...props} />
            <Nuevo onSave={onSave} /> 
            <NuevoUsers onSave={onSave} /> 
            <DataGrid
                ref={dataGrid}
                dataSource={store({uri : uri.goals })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                columnAutoWidth={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                    
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={10} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={true} fileName={title} allowExportSelectedData={true} />         
                <Column type="buttons" width={90}>
                    <ButtonGrid name="asign" icon="menu" onClick={e => showDialogUsers(e.row.data)}/>
                </Column>              
                <Column dataField="description" caption="Descripción" visible={true}/>           
                <Column dataField="initDate" caption="Fecha Inicio" width={120} visible={true} dataType="date" format={formatDate} />
                <Column dataField="endDate" caption="Fecha Fin" width={120} visible={true} dataType="date" format={formatDate} />
                <Column dataField="value" caption="Meta" width={180} cellRender={cellRender()} />       
                <Column dataField="active" caption="Active" width={120}/>       
                
                <Column type="buttons" width={90}>
                    <ButtonGrid name="edit" icon="edit" onClick={e => showDialog(e.row.data.id)}/>
                    <ButtonGrid name="delete" />
                </Column>  
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                    <Popup title={title} showTitle={true} width={800} height={580}>

                    </Popup>                   
                </Editing>
            </DataGrid>
        </div>
    )


}


export default Goals;
